var _excluded = ["inputSize", "dropdownSize", "filterItems", "prefixWidth", "withSearchIcon", "status", "className", "inputClassName", "onSelectChange", "onSearchBtnClick", "style"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useCallback, useMemo, useState } from 'react';
import { DownOutlined, SearchOutlined } from '@aelf-design/icons';
import Dropdown from "../Dropdown";
import Input from "../Input";
import useStyles from "./style";
function Search(_ref) {
  var _ref$inputSize = _ref.inputSize,
    inputSize = _ref$inputSize === void 0 ? 'middle' : _ref$inputSize,
    _ref$dropdownSize = _ref.dropdownSize,
    dropdownSize = _ref$dropdownSize === void 0 ? 'default' : _ref$dropdownSize,
    _ref$filterItems = _ref.filterItems,
    filterItems = _ref$filterItems === void 0 ? [] : _ref$filterItems,
    prefixWidth = _ref.prefixWidth,
    withSearchIcon = _ref.withSearchIcon,
    status = _ref.status,
    className = _ref.className,
    inputClassName = _ref.inputClassName,
    onSelectChange = _ref.onSelectChange,
    onSearchBtnClick = _ref.onSearchBtnClick,
    style = _ref.style,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(filterItems[0]),
    _useState2 = _slicedToArray(_useState, 2),
    checkedItem = _useState2[0],
    setCheckedItem = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDropDownOpen = _useState4[0],
    setIsDropDownOpen = _useState4[1];
  var _useStyles = useStyles({
      prefixWidth: prefixWidth,
      inputSize: inputSize,
      withSearchIcon: withSearchIcon
    }),
    styles = _useStyles.styles,
    cx = _useStyles.cx;
  var isMiddleSize = inputSize === 'middle';
  var isInlineSearchIcon = withSearchIcon === 'inline';
  var isNotInlineSearchIcon = withSearchIcon === 'connect' || withSearchIcon === 'after';
  var isErrorStatus = status === 'error';
  var searchBtnClickHandler = useCallback(function (e) {
    if (isErrorStatus) {
      return;
    }
    onSearchBtnClick === null || onSearchBtnClick === void 0 || onSearchBtnClick(e);
  }, [onSearchBtnClick, isErrorStatus]);
  var searchBtnNode = /*#__PURE__*/React.createElement("div", {
    onClick: searchBtnClickHandler,
    className: cx(isInlineSearchIcon ? styles.searchBtnInline : styles.searchBtn, isErrorStatus && styles.searchBtnDisabled)
  }, /*#__PURE__*/React.createElement(SearchOutlined, null));
  var filterClickHandler = useCallback(function (obj) {
    var idx = filterItems.findIndex(function (ele) {
      return (ele === null || ele === void 0 ? void 0 : ele.key) === obj.key;
    });
    setCheckedItem(filterItems[idx]);
    setIsDropDownOpen(false);
    onSelectChange === null || onSelectChange === void 0 || onSelectChange(obj);
  }, [filterItems, onSelectChange]);
  var onOpenChangeHandler = useCallback(function (open) {
    setIsDropDownOpen(open);
  }, []);
  var prefixDom = useMemo(function () {
    if (filterItems.length === 0) {
      return /*#__PURE__*/React.createElement(SearchOutlined, null);
    }
    return /*#__PURE__*/React.createElement(Dropdown, {
      menu: {
        items: filterItems,
        selectable: true,
        onClick: filterClickHandler,
        defaultSelectedKeys: ["".concat(checkedItem === null || checkedItem === void 0 ? void 0 : checkedItem.key)]
      },
      size: dropdownSize,
      trigger: ['click'],
      offsetX: isMiddleSize ? -12 : -8,
      offsetY: isMiddleSize ? 10 : 6,
      onOpenChange: onOpenChangeHandler
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.searchDropDownWrap
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.searchDropDownLeft
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.searchDropDownLeftLabel
    }, checkedItem === null || checkedItem === void 0 ? void 0 : checkedItem.value), /*#__PURE__*/React.createElement(DownOutlined, {
      className: cx(isDropDownOpen && styles.collapseIcon)
    })), /*#__PURE__*/React.createElement("div", {
      className: styles.searchDropDownRight
    }, /*#__PURE__*/React.createElement(SearchOutlined, null))));
  }, [checkedItem === null || checkedItem === void 0 ? void 0 : checkedItem.key, checkedItem === null || checkedItem === void 0 ? void 0 : checkedItem.value, cx, dropdownSize, filterClickHandler, filterItems, isDropDownOpen, isMiddleSize, onOpenChangeHandler, styles.collapseIcon, styles.searchDropDownLeft, styles.searchDropDownLeftLabel, styles.searchDropDownRight, styles.searchDropDownWrap]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.search, className),
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.searchInput
  }, /*#__PURE__*/React.createElement(Input, _extends({}, props, {
    status: status,
    size: inputSize,
    prefix: prefixDom,
    className: inputClassName,
    suffix: isInlineSearchIcon && searchBtnNode
  }))), isNotInlineSearchIcon && searchBtnNode);
}
export default Search;